export default __webpack_public_path__ + "static/media/no_result.4976bf97.svg";